import {
  faCircle,
  faDiamond,
  faSquare,
  faTriangle,
  type IconDefinition,
} from "@fortawesome/sharp-solid-svg-icons"

export type ShapeType = "circle" | "triangle" | "square" | "diamond"

// Shape arrays for different chart types
export const WASTEWATER_SHAPES = [
  "triangle",
  "circle",
  "square",
  "diamond",
] as const satisfies readonly ShapeType[]

export const CLINICAL_SHAPES = [
  "circle",
  "triangle",
  "square",
] as const satisfies readonly ShapeType[]

export const SHAPE_ICONS: Record<ShapeType, IconDefinition> = {
  circle: faCircle,
  triangle: faTriangle,
  square: faSquare,
  diamond: faDiamond,
}

export interface BaseLegendItemData {
  id: string
  label: string
  color: string
  shape: ShapeType
}
